import styled, { css } from "styled-components";

export const Container = styled.div`
  z-index: 100000;
  position: fixed;
  background: var(--fd-colors-component-data-input-background-base);
  border: 1px solid #d6e3f0;
  box-shadow: 0 2px 4px rgba(17, 43, 68, 0.18);
  border-radius: 2px;
  width: 170px;

  @media screen and (max-width: 390px) {
    right: auto;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.button<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  width: 170px;
  padding: 12px;
  background: var(--fd-colors-component-data-input-background-base);
  height: 42px;
  cursor: pointer;

  &:hover {
    background-color: var(--fd-colors-component-data-input-background-hover);
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background: var(--fd-colors-component-data-input-background-hover);
      box-shadow:
        inset 2px 0 0 #5390ed,
        inset 0 -1px 0 #d6e3f0;
    `};
`;
